import React from 'react';
import { RestrictedContentProvider } from '../../components/restricted-content';

export const TaskMaintenance = () : JSX.Element => (
    <RestrictedContentProvider projectManagerOnly>
        <p>Task maintenance coming soon!</p>
    </RestrictedContentProvider>
);
